export default function SidebarButton({ icon: Icon, label, onClick, variant = 'default', isCompact = false }) {
  const baseClasses = `group flex items-center gap-3 rounded-lg transition-all duration-200 ${
    isCompact ? 'justify-center p-2' : 'w-full px-2 py-3'
  }`;

  const variantClasses = {
    default: 'text-teal-100 hover:bg-white/10 hover:text-white',
    danger: 'text-red-300 hover:bg-red-500/20 hover:text-red-200',
  };

  const iconBgClasses = {
    default: 'bg-white/5 group-hover:bg-white/10',
    danger: 'bg-red-500/10 group-hover:bg-red-500/20',
  };

  return (
    <button
      onClick={onClick}
      title={isCompact ? label : undefined}
      className={`${baseClasses} ${variantClasses[variant]}`}
    >
      <div
        className={`flex items-center justify-center rounded-md transition-all duration-200 ${
          isCompact ? 'h-6 w-6' : 'h-7 w-7'
        } ${iconBgClasses[variant]}`}
      >
        <Icon size={isCompact ? 16 : 18} />
      </div>
      {!isCompact && <span className="truncate text-sm font-medium">{label}</span>}
    </button>
  );
}
